import './shortcuts.scss'

import React from 'react'

import { Shortcut } from '../../../../components/ui/Shortcut'

import type { Shortcuts as ShortcutsClubCardUserProps } from '../../../../types/ClubCard/ClubCardUser'

interface ShortcutsProps extends ShortcutsClubCardUserProps {
  isInline?: boolean
}

const LIMIT_SHORTCUTS = 6

export const Shortcuts = ({
  visibility,
  list,
  location,
  isInline,
}: ShortcutsProps) => {
  if (!visibility || !list?.length) {
    return null
  }

  const listShortcuts = list.slice(0, LIMIT_SHORTCUTS)
  const shortcutClass = !isInline ? `shortcuts-${listShortcuts.length}` : ''

  return (
    <div className={`club-card-user-shortcuts ${shortcutClass}`}>
      {listShortcuts?.map((itemShortcut, index) => (
        <Shortcut
          key={`${itemShortcut.label}-${index}`}
          text={itemShortcut.label}
          icon={itemShortcut.icon}
          href={itemShortcut.href}
          location={location}
          deepLink={itemShortcut.deepLink}
        />
      ))}
    </div>
  )
}
